import { StylableCompatUniDriver } from './stylable-unidriver-util-legacy';

export const StylableUnidriverUtil = StylableCompatUniDriver;
